// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__2Cytt","row":"styles_row__3WUS2","column":"styles_column__1XfyF","cell":"styles_cell__ad3hs"};